<template>
  <!-- 房客详情 -->
  <div>
    <div class="userinfo">
      <div class="info_left">
        <div class="info_left_img">
          <img src="../../image/userimg.png" />
        </div>
        <div class="info_left_text">
          <div class="userName">{{ TenantDetailsList.nickName }}</div>
          <div class="authentication" v-if="TenantDetailsList.isRealName == 1">
            已认证
          </div>
          <div class="authentication_else" v-else>未认证</div>
          <div class="userNumber">
            手机号：{{ TenantDetailsList.phonenumber }}
          </div>
        </div>
      </div>
      <div class="info_right">
        <el-button
          v-if="
            TenantDetailsList.status == '1' && premission('Switch:Guest:status')
          "
          type="danger"
          style="backgroundColor: #EB5757;border:1px solid  #EB5757 "
          @click="TenantChangeStatusAjax"
          >禁用</el-button
        >
        <el-button
          type="danger"
          v-if="
            TenantDetailsList.status == '0' && premission('Switch:Guest:status')
          "
          style="backgroundColor: #EB5757;border:1px solid  #EB5757 "
          @click="TenantChangeStatusAjax"
          >启用</el-button
        >
        <el-button
          type="warning"
          style="backgroundColor:#219653;border:1px solid #219653 "
          @click="resetPasswordBtn"
          v-if="premission('Reset:Guest:password')"
          >重置密码</el-button
        >
        <el-button
          type="info"
          style="backgroundColor:#F6B439;border:1px solid #F6B439 "
          @click="levelUp"
          v-if="premission('Upgrade:landlord')"
          >升级为房东</el-button
        >
        <el-button
          type="success"
          style="backgroundColor:#EF6E2D;border:1px solid #EF6E2D "
          @click="deleteTenant"
          v-if="premission('Delete:Guest')"
          >删除</el-button
        >
        <el-button
          type="primary"
          style="backgroundColor:#2F80ED;border:1px solid #2F80ED "
          @click="editInformation"
          v-if="premission('Edit:Guest')"
          >编辑</el-button
        >
      </div>
    </div>
    <div class="title">用户基本信息</div>
    <div class="user_message">
      <div class="message">
        <div class="message_left">生日：{{ TenantDetailsList.birthday }}</div>
        <div class="message_right">
          常住城市：{{ TenantDetailsList.city }}
        </div>
      </div>
      <div class="message">
        <div class="message_left">
          性别：{{ TenantDetailsList.sex == 1 ? "男" : "女" }}
        </div>
        <div class="message_right">
          注册时间：{{ TenantDetailsList.createTime }}
        </div>
      </div>
      <div class="message">
        <div class="message_left">年龄：{{ TenantDetailsList.age }}</div>
        <div class="message_right">
          来源：{{ TenantDetailsList.registeredSource }}
        </div>
      </div>
      <div class="message">
        <div class="message_left">用户属性：{{ TenantDetailsList.profession || '散户' }}</div>
         <div class="message_right">身份证号：{{TenantDetailsList.cCusIdCard}}</div>
      </div>
    </div>
    <div class="title">消费基本信息</div>
    <div class="user_message">
      <div class="message">
        <div class="message_left">消费金额：</div>
        <div class="message_right">退房记录：</div>
      </div>
      <div class="message">
        <div class="message_left">订单数量：</div>
        <div class="message_right">平均单价：</div>
      </div>
      <div class="message">
        <div class="message_left">订房天数：</div>
        <div class="message_right">收藏房源数：</div>
      </div>
      <div class="message">
        <div class="message_left">商品评价：</div>
        <div class="message_right">登录次数0次</div>
      </div>
    </div>
    <div class="title">订单记录</div>
    <!-- 表单数据 -->
    <el-table :data="orderDetails" style="width: 100%">
      <el-table-column prop="orderId" label="订单编号" width="180">
      </el-table-column>
      <el-table-column prop="commitTime" label="提交时间" width="180">
      </el-table-column>
      <el-table-column prop="name" label="用户账号" width="180">
      </el-table-column>
      <el-table-column prop="money" label="订单金额" width="180">
      </el-table-column>
      <el-table-column prop="payType" label="支付方式" width="180">
      </el-table-column>
      <el-table-column prop="source" label="订单来源" width="180">
      </el-table-column>
      <el-table-column prop="status" label="订单状态" width="180">
      </el-table-column>
      <el-table-column prop="name" label="状态"> </el-table-column>
    </el-table>

    <!-- 编辑个人档案弹窗 -->
    <el-dialog
      title="个人档案"
      class="title_center"
      :visible.sync="userInfoVisible"
      width="600px"
      :show-close="false"
    >
      <el-form :model="userInfo" ref="userInfoFrom" :rules="rules" label-width="120px">
        <el-form-item label="身份证号：" prop="cCusIdCard">
          <el-input
            v-model="userInfo.cCusIdCard"

            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="生日：" prop="birthday">
            <el-date-picker
                style="width: 100%;"
                value-format="yyyy-MM-dd"
                v-model="userInfo.birthday"
                type="date"
                placeholder="生日">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="性别：">
          <el-radio v-model="userInfo.sex" label="1">男</el-radio>
          <el-radio v-model="userInfo.sex" label="0">女</el-radio>
        </el-form-item>
        <el-form-item label="昵称：">
          <el-input v-model="userInfo.nickName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="职业：">
          <el-input v-model="userInfo.profession" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" class="cancel">取 消</el-button>
        <el-button type="primary" @click="userInfoBtn" class="success_Btn"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 重置密码 -->
    <el-dialog
      title="重置密码"
      class="title_center"
      :visible.sync="resetVisible"
      width="600px"
      :show-close="false"
    >
      <div class="resetPassText">
        是否将账号密码重置为初始密码（初始密码为12345678）
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" class="cancel">取 消</el-button>
        <el-button type="primary" @click="resetUser" class="success_Btn"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 升级为房东 -->
    <el-dialog
      title="升级为房东"
      :visible.sync="levelUpVisible"
      width="600px"
      :show-close="false"
    >
      <div class="level_radio">
        <el-radio v-model="landlordType" label="0">个人房东</el-radio>
        <el-radio v-model="landlordType" label="1">悠家直营</el-radio>
      </div>
      <div class="level_hint">是否确认将房客升级为房东</div>
      <div class="level_hint">
        <span>*</span>升级为房东后将可以在悠家平台上传并管理房源
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" class="cancel">取 消</el-button>
        <el-button type="primary" @click="levelUpBtn" class="success_Btn"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  TenantDetailsAjax,
  TenantChangeStatus,
  TenantDelete,
  resetUserPwd
} from "../../api/index";
import premission from "../../utils/permission";
export default {
  mixins: [premission],
  data() {
      let validateIdCard = (rule, value, callback) => {
          let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
          if (!reg.test(value)) {
              callback(new Error('身份证不合法!'));
          }else {
              let birthday=''
              if(value.length == 15){
                  birthday = "19"+value.substr(6,6);
              } else if(value.length == 18){
                  birthday = value.substr(6,8);
              }

              this.userInfo.birthday =!this.userInfo.birthday? birthday.replace(/(.{4})(.{2})/,"$1-$2-"):this.userInfo.birthday;
              if(!this.userInfo.sex){
                  parseInt(value.slice(-2, -1)) % 2 == 1?this.userInfo.sex = '1': this.userInfo.sex = '0'
              }


              console.log(this.userInfo.birthday)
              callback();
          }
      };
    return {
      levelUpVisible: false,
      resetVisible: false,
      userInfoVisible: false,
      // 个人信息
      landlordType: "1",
      userInfo: {
        customerId: "",
        idCard: "",
        birthday: "",
        sex: "1",
        profession: "",
        nickName: ""
      },

      // 用户id
      customerId: "",
      TenantDetailsList: [],
      orderDetails: [],
      rules: {
          cCusIdCard: [
                { required: true, message: '请输入身份证', trigger: 'blur' },
                { validator: validateIdCard, trigger: 'blur' }
            ],
            birthday: [
                { required: true, message: '请选中出生日期', trigger: 'blur' }
            ],
        }
    };
  },
  created() {
    if (this.$route.params.customerId) {
      sessionStorage.setItem("TenantcustomerId", this.$route.params.customerId); //将params中的值存在本地，并且当他为空时不刷新
    }
    this.userInfo.customerId = sessionStorage.getItem("LandlordcustomerId");
    this.customerId = sessionStorage.getItem("TenantcustomerId");
    this.getTenantDetailsAjax();
  },
  methods: {
    // 获取房客信息
    async getTenantDetailsAjax() {
      const { data: res } = await TenantDetailsAjax(this.customerId);
      if (res.code !== 200) {
        return this.$message({
          type: "error",
          message: res.msg
        });
      }
      this.TenantDetailsList = res.data.customer;
      this.orderDetails = res.data.customerLog;
    },
    // 编辑信息
    editInformation() {
      this.userInfoVisible = true;
      this.userInfo=this.TenantDetailsList
    },

    // 修改房客状态
    async TenantChangeStatusAjax() {
      let text = this.TenantDetailsList.status === "0" ? "启用" : "禁用";
      var status = this.TenantDetailsList.status === "0" ? "1" : "0";
      this.$confirm("是否确认" + text + "？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const { data: res } = await TenantChangeStatus({
            status: status,
            customerId: this.customerId
          });

          if (res.code !== 200) {
            status = this.TenantDetailsList.status === "0" ? "1" : "0";
            return this.$message({
              type: "error",
              message: res.msg
            });
          }
          this.$message({
            type: "success",
            message: res.msg
          });
          this.getTenantDetailsAjax();
        })

        .catch(() => {
          status = this.TenantDetailsList.status === "0" ? "1" : "0";
        });
    },
    // 删除用户
    deleteTenant() {
      this.$confirm("是否确认删除？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // cancelButtonClass: "cancel_btn", //取消自定义类名
        // confirmButtonClass: "confirm_btn", //确认自定义类名
        type: "warning"
      })
        .then(async () => {
          const { data: res } = await TenantDelete(this.customerId);
          if (res.code !== 200) {
            return this.$message({
              type: "error",
              message: res.msg
            });
          }
          this.$message({
            type: "success",
            message: res.msg
          });
          this.getTenantDetailsAjax();
          this.$router.go(-1);
        })
        .catch(() => {
          console.log(1);
        });
    },
    // 取消按钮
    cancel() {
      this.userInfoVisible = false;
      this.resetVisible = false;
      this.levelUpVisible = false;
      this.userInfo = {
        customerId: "",
        cCusIdCard: "",
        birthday: "",
        sex: "1",
        profession: "",
        nickName: ""
      };
    },
    // 重置按钮
    resetPasswordBtn() {
      this.resetVisible = true;
    },
    // 升级按钮
    levelUp() {
      this.levelUpVisible = true;
    },
    // 编辑个人信息
    async userInfoBtn() {
        console.log(this.userInfo.birthday)

        let flag=false
        this.$refs['userInfoFrom'].validate((valid) => {
            flag=valid
        });
        if (!flag) {
            this.$message.error('您的输入有误')
            return;
        }
      const { data: res } = await TenantChangeStatus(this.userInfo);
      if (res.code !== 200) {
        return this.$message({
          type: "error",
          message: res.msg
        });
      } else {
        this.userInfoVisible = false;
        this.getTenantDetailsAjax();
        return this.$message({
          type: "success",
          message: res.msg
        });
      }
    },
    // 升级为房东
    async levelUpBtn() {
      const { data: res } = await TenantChangeStatus({
        landlordType: this.landlordType,
        customerId: this.customerId,
        isLandlord: "1"
      });
      if (res.code !== 200) {
        return this.$message({
          type: "error",
          message: res.msg
        });
      } else {
        this.$router.push({
          name: "landlordManagement" //跳转的路径
        });
        this.levelUpVisible = false;
        this.getTenantDetailsAjax();
        return this.$message({
          type: "success",
          message: res.msg
        });
      }
    },
    // 重置密码
    async resetUser() {
      const { data: res } = await resetUserPwd(this.customerId, "12345678");
      if (res.code !== 200) {
        return this.$message({
          type: "error",
          message: res.msg
        });
      } else {
        this.resetVisible = false;
        this.getTenantDetailsAjax();
        return this.$message({
          type: "success",
          message: res.msg
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.userinfo {
  height: 180px;
  margin-bottom: 30px;
  .info_left {
    width: 466px;
    float: left;
    .info_left_img {
      float: left;
      overflow: hidden;
      border-radius: 50%;
      width: 150px;
      height: 150px;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .info_left_text {
      float: left;
      margin-left: 30px;
      .userName {
        margin-top: 10px;
        font-family: Microsoft YaHei;
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
      }
      .authentication {
        margin-top: 15px;
        font-weight: bold;
        width: 72px;
        height: 30px;
        font-size: 16px;
        text-align: center;
        line-height: 30px;
        color: #fff;
        border-radius: 6px;
        background-color: #f6b439;
      }
      .authentication_else {
        margin-top: 15px;
        font-weight: bold;
        width: 72px;
        height: 30px;
        font-size: 16px;
        text-align: center;
        line-height: 30px;
        color: #fff;
        border-radius: 6px;
        background-color: #d2d2d2;
      }
      .userNumber {
        margin-top: 38px;
        font-size: 18px;
      }
    }
  }
  .info_right {
    float: right;
    height: 48px;
    width: 900px;
    margin-top: 102px;
    .el-button {
      font-size: 16px;
      height: 48px;
      width: 120px;
      float: right;
      margin: 0;
      margin-right: 30px;
    }
  }
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.title {
  position: relative;
  width: 150px;
  height: 26px;
  line-height: 26px;
  font-size: 20px;
  text-indent: 15px;
}
.title::before {
  position: absolute;
  left: 0px;
  top: -3px;
  height: 36px;
  width: 6px;
  content: "";
  border-radius: 3px;
  background-color: #f6b439;
}
.user_message {
  margin-top: 25px;
  padding: 20px 15px;
  margin-bottom: 60px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  .message {
    position: relative;
    height: 45px;
    font-size: 16px;
    .message_left {
      position: absolute;
      top: 0px;
      left: 0px;
      line-height: 45px;
    }
    .message_right {
      position: absolute;
      top: 0px;
      left: 548px;
      line-height: 45px;
    }
  }
}
.el-table {
  margin-top: 10px;
}
/deep/.el-dialog__body {
  padding: 40px 55px 18px 55px;
  .el-form-item {
    margin-bottom: 30px;
  }
  .el-form-item__label {
    height: 36px;
    line-height: 36px;
  }
  .el-input {
    height: 36px;
    .el-input__inner {
      height: 36px;
      line-height: 36px;
    }
  }
}

/deep/.el-radio__label {
  font-size: 16px;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #f6b439;
}
/deep/.el-radio__inner {
  width: 24px;
  height: 24px;
}
/deep/.el-radio__inner::after {
  width: 10px;
  height: 10px;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #f6b439;
  background: #f6b439;
  width: 24px;
  height: 24px;
}
.cancel {
  width: 72px;
  height: 36px;
  background-color: #f2f2f2;
  border: 1px solid #e1e1e1;
  box-sizing: border-box;
  border-radius: 4px;
}
.success_Btn {
  margin-left: 24px;
  width: 72px;
  height: 36px;
  background-color: #f6b439;
  border: 1px solid #f6b439;
  box-sizing: border-box;
  border-radius: 4px;
}
/deep/.el-dialog__header {
  padding: 40px 55px 0;
}
/deep/.el-dialog__footer {
  padding: 10px 55px 20px;
}
.title_center {
  /deep/.el-dialog__header {
    text-align: center;
  }
}
.resetPassText {
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.333333px;
  text-align: center;
  color: #999999;
}
.level_radio {
  display: flex;
  .el-radio {
    text-align: center;
    flex: 1;
  }
}
.level_hint {
  margin-top: 20px;
  text-align: center;
  span {
    color: red;
  }
}
</style>
